export const addSessionResults = {
    namespaced: true,

    state: {
        step: 1,
        sessionType: null
    }
};
